import { Component, Input, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { FUNNEL_STEP, User } from '../../common/user';
import { formatDuration, FUNNEL_TEXT, FunnelRow, funnelSummary, FunnelUser, FunnelUserMode, usersAtStep } from './funnel';

const DAY = 24 * 60 * 60 * 1000

// how far users who registered themselves get through getting started, for the sys admin users page. Choosing a step
// lists its users: everyone who reached it, or those who got no further
@Component({
    selector: 'app-onboarding-funnel',
    templateUrl: './onboarding-funnel.html',
    styleUrls: ['./onboarding-funnel.css'],
    standalone: true,
    imports: [MaterialModule, FormsModule, DatePipe]
})
export class OnboardingFunnelComponent implements OnChanges {
    @Input() users:User[]

    periods = [
        {days: 7, label: '7 days'},
        {days: 30, label: '30 days'},
        {days: 90, label: '90 days'},
        {days: 0, label: 'All time'},
    ]
    days = 30
    rows:FunnelRow[] = []

    selectedStep?:FUNNEL_STEP
    mode:FunnelUserMode = 'reached'
    stepUsers:FunnelUser[] = []

    FUNNEL_TEXT = FUNNEL_TEXT
    formatDuration = formatDuration

    ngOnChanges(): void {
        this.refresh()
    }

    refresh() {
        const since = this.days ? new Date(Date.now() - this.days * DAY) : undefined
        const users = this.users || []
        this.rows = funnelSummary(users, since)
        this.stepUsers = this.selectedStep ? usersAtStep(users, this.selectedStep, since, this.mode) : []
    }

    // a step chosen again closes its list
    select(step:FUNNEL_STEP) {
        this.selectedStep = this.selectedStep === step ? undefined : step
        this.refresh()
    }

    get registered() {
        return this.rows[0]?.count || 0
    }
}
